import { useEffect } from 'react'
import { initServiceWorkerUpdateCoordinator } from '../../serviceWorker/serviceWorkerUpdateCoordinator'
import { AppUpdateBanner } from './AppUpdateBanner'

export function AppUpdateBootstrap() {
  useEffect(() => {
    return initServiceWorkerUpdateCoordinator()
  }, [])

  return <AppUpdateBanner />
}
